import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0feaed72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "SelectedFiltersHeader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-redo2 ButtonIcon" }, null, -1 /* HOISTED */))
const _hoisted_3 = {
  key: 2,
  class: "FilterTagContainer Collapsed",
  ref: "filterTagContainerRef"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-plus ButtonIcon" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-minus ButtonIcon" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tracking = _resolveComponent("Tracking")!
  const _component_SelectedFiltersSkeletonLoader = _resolveComponent("SelectedFiltersSkeletonLoader")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["SelectedFiltersContainer", { Visible: _ctx.filtersApplied || _ctx.isBusy}])
  }, [
    (_ctx.filtersApplied || _ctx.isBusy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" Selected filters "),
          (_ctx.removableFiltersCount > 0 && !_ctx.isBusy)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ClearButton",
                ref: "clearAllButtonRef",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.removableFiltersCount === 1 ? 'Clear filter' : `Clear ${_ctx.removableFiltersCount} filters`) + " ", 1 /* TEXT */),
                _hoisted_2
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true),
          (_ctx.clearAllButtonTrackingData)
            ? (_openBlock(), _createBlock(_component_Tracking, {
                key: 1,
                data: _ctx.clearAllButtonTrackingData
              }, null, 8 /* PROPS */, ["data"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isBusy)
      ? (_openBlock(), _createBlock(_component_SelectedFiltersSkeletonLoader, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.id
            }, [
              _createVNode(_component_Tag, { tag: tag }, null, 8 /* PROPS */, ["tag"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */)),
    _createElementVNode("div", null, [
      (_ctx.shouldDisplayShowMore)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ShowMoreButton",
            ref: "showMoreButtonRef",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
          }, [
            _createTextVNode(" Show more "),
            _hoisted_4
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (_ctx.shouldDisplayShowLess)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "ShowLessButton",
            ref: "showLessButtonRef",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showLess && _ctx.showLess(...args)))
          }, [
            _createTextVNode(" Show less "),
            _hoisted_5
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}